module.exports = __webpack_public_path__ + "static/media/om_hairstyle_buzz_front.3e345d08.png";